<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import R, {LOADER} from "../lib/requests";
    import {LOCATION_TYPE, ROUTE_TYPE, ROUTE_TYPES} from "../lib/constants";
    import {formatDate, getDate, humanDate} from "../lib/lib";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import CalendarNavigation from "./CalendarNavigation.svelte";
    import Alert from "../stores/alerts";

    export let date = null;

    const breadcrumb = [
        {id: 'calendar', name: 'Calendar', link: `/app/calendar`}
    ];
    const pageHeaderControls = [
        {id: 'today', name: 'TODAY'},
    ];

    const paymentTypes = [
        'ON ACC',
        'CASH',
        'CPL',
        'CC',
    ];

    let transfers = null;
    let transfersDate = null;

    const load = () => {
        const onSuccess = result => {
            transfers = result;

            transfers.map(item => {
                item.route_label = ROUTE_TYPES[item.route_type].toUpperCase();
                item.pickup_name = item.pickup.name + (item.pickup.address ? ", " + item.pickup.address : "");
                item.drop_name = item.drop.name + (item.drop.address ? ", " + item.drop.address : "");

                item.flight_label = "";
                if (item.route_type == ROUTE_TYPE.ARRIVAL && item.pickup) {
                    if (item.pickup.type_id == LOCATION_TYPE.AIRPORT) {
                        item.flight_label = "FLIGHT NO";
                    } else if (item.pickup.type_id == LOCATION_TYPE.PORT) {
                        item.flight_label = "BOAT";
                    }
                } else if (item.route_type == ROUTE_TYPE.DEPARTURE && item.drop) {
                    if (item.drop.type_id == LOCATION_TYPE.AIRPORT) {
                        item.flight_label = "FLIGHT NO";
                    } else if (item.drop.type_id == LOCATION_TYPE.PORT) {
                        item.flight_label = "BOAT";
                    }
                }
            });
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading transfers.";
            Alert.warning("Transfers", message);
        };

        transfersDate = date;
        let data = {
            transfer_at: date,
            sort_field: 'transfer_at',
            sort_way: 'ASC',
        }
        R.handle(R.transfer.dayTransfers, data, onSuccess, onFailure, LOADER.PAGE);
    }

    const onPreviousDay = () => {
        let dt = new Date(date);
        date = formatDate(new Date(dt.getTime() - 24 * 60 * 60 * 1000), 'y-m-d')
        router.go(`/app/calendar/${date}`)();
    }

    const onNextDay = () => {
        let dt = new Date(date);
        date = formatDate(new Date(dt.getTime() + 24 * 60 * 60 * 1000), 'y-m-d');
        router.go(`/app/calendar/${date}`)();
    }

    const onToday = () => {
        date = getDate();
        router.go(`/app/calendar/${date}`)();
    }

    load();

    $: {
        if (transfersDate !== date) {
            load();
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="Daily Transfers" controls={ pageHeaderControls } on:today={ onToday }/>
<CalendarNavigation title="{ humanDate(date) }"
                    on:click_previous="{ onPreviousDay }"
                    on:click_next="{ onNextDay }"/>
{#if transfers != null}
    {#each transfers as transfer}
        <div class="panel panel-simple day-transfer">
            <div class="column left">
                <div class="time fw-semibold">
                    { formatDate(transfer.transfer_at, 'H:i') }
                </div>
                <div class="route-label mb-4">
                    { transfer.route_label }
                </div>
                <div class="small">PAX</div>
                <div class="text-gray fw-semibold mb-4">
                    { transfer.passengers }
                </div>
                <!--{#if transfer.price && user.canViewTransferPrice()}-->
                <!--    <div class="small">CASH</div>-->
                <!--    <div class="text-gray fw-semibold">-->
                <!--        { transfer.price }-->
                <!--    </div>-->
                <!--{/if}-->
                {#if transfer.price && user.canViewTransferPrice()}
                    <div class="small">{ paymentTypes[transfer.payment_type] }</div>
                    <div class="text-gray fw-semibold">
                        { transfer.price }
                    </div>
                {/if}
            </div>
            <div class="content border-left">
                <div class="column fw-semibold border-bottom">
                    { transfer.pickup_name } &#10140; { transfer.tour ? transfer.tour.name : transfer.drop_name }
                </div>
                <div class="customer">
                    <div class="name column border-bottom">
                        <div class="small">Customer</div>
                        { transfer.customer.fullname }
                    </div>
                    <div class="details border-bottom">
                        <div class="column">
                            <div class="small">PHONE</div>
                            <a href="tel:{ transfer.customer.phone }">{ transfer.customer.phone }</a>
                        </div>
                        <div class="column">
                            <div class="small">ROOM NO</div>
                            { transfer.customer.room_no }
                        </div>
                        <div class="column">
                            <div class="small">{ transfer.flight_label }</div>
                            { transfer.flight_no }
                        </div>
                    </div>
                </div>
                <div class="passengers border-bottom">
                    <div class="d-flex"
                         class:border-after={ transfer.booster_seats > 0 || transfer.baby_seats > 0 || transfer.infant_seats > 0 }>
                        <div class="column text-center">
                            <div class="small">
                                ADULTS
                            </div>
                            { transfer.adults }
                        </div>
                        {#if transfer.children > 0}
                            <div class="column text-center">
                                <div class="small">
                                    CHILDREN
                                </div>
                                { transfer.children }
                            </div>
                        {/if}
                        {#if transfer.infants > 0}
                            <div class="column text-center">
                                <div class="small">
                                    INFANTS
                                </div>
                                { transfer.infants }
                            </div>
                        {/if}
                    </div>
                    <div class="d-flex">
                        {#if transfer.booster_seats > 0}
                            <div class="column text-center">
                                <div class="small">
                                    BOOSTERS
                                </div>
                                { transfer.booster_seats }
                            </div>
                        {/if}
                        {#if transfer.baby_seats > 0}
                            <div class="column text-center">
                                <div class="small">
                                    BABY SEATS
                                </div>
                                { transfer.baby_seats }
                            </div>
                        {/if}
                        {#if transfer.infant_seats > 0}
                            <div class="column text-center">
                                <div class="small">
                                    INFANT SEATS
                                </div>
                                { transfer.infant_seats }
                            </div>
                        {/if}
                    </div>
                </div>
                <div class="driver border-bottom">
                    {#if transfer.driver}
                        <div class="column">
                            { transfer.driver.name }
                        </div>
                    {/if}
                    <div class="column">
                        {#if transfer.vehicle}
                            { transfer.vehicle.licence_no }
                            <span class="vehicle-type">
                                ({ app.vehicleTypeName(transfer.vehicle.vehicle_type_id) })
                            </span>
                        {:else}
                            <span class="text-light">no vehicle yet</span>
                        {/if}
                    </div>
                </div>
                {#if transfer.notes || transfer.driver_notes}
                    <div class="column fst-italic text-gray">
                        {#if transfer.notes}
                            <div>{@html transfer.notes.replaceAll("\n", "<br>") }</div>
                        {/if}
                        {#if transfer.driver_notes}
                            <div>{@html transfer.driver_notes.replaceAll("\n", "<br>") }</div>
                        {/if}
                    </div>
                {/if}
            </div>
        </div>
    {/each}
    {#if !transfers.length}
        <div class="panel-simple panel-pad">
            No transfers found for this day.
        </div>
    {/if}
{/if}

<style>
    .day-transfer {
        display: flex;
        margin-bottom: 20px;
    }

    .day-transfer .column {
        padding: 7px 5px;
    }

    .day-transfer .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 55px;
    }

    .day-transfer .time {
        margin-bottom: 3px;
    }

    .day-transfer .content {
        width: 100%;
    }

    .day-transfer .route {

    }

    .day-transfer .route-label {
        font-size: 10px;
        letter-spacing: -0.6px;
        text-transform: uppercase;
    }

    .day-transfer .small {
        font-size: 10px;
        text-transform: uppercase;
        color: #a7a7a7;
    }

    .day-transfer .customer {

    }

    .day-transfer .customer .details {
        display: flex;
        justify-content: space-between;
        min-width: 230px;
        width: 100%;
    }

    .day-transfer .vehicle-type {
        color: #a5a5a5;
    }

    .day-transfer .border-left {
        border-left: 1px dotted var(--default-border-color);
    }

    .day-transfer .border-bottom {
        border-bottom: 1px dotted var(--default-border-color) !important;
    }

    @media (min-width: 577px) {
        .day-transfer .left {
            min-width: 70px;
        }

        .day-transfer .column {
            padding: 10px 10px;
        }

        .day-transfer .customer {
            display: flex;
        }

        .day-transfer .customer .name {
            width: 100%;
        }

        .day-transfer .customer .details {
            justify-content: space-around;
        }

        .day-transfer .passengers {
            display: flex;
        }

        .day-transfer .driver {
            display: flex;
        }
    }
</style>